import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

import { Role } from '../models/role';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  private readonly baseUrl = `${environment.apiUrl}/roles`;

  constructor(private http: HttpClient) { }

  getAllRoles(): Observable<Role[]> {
    return this.http.get<Role[]>(this.baseUrl).pipe(
      map(roles => roles.sort((a, b) => {
        const dateA = a.modifiedDate ? new Date(a.modifiedDate).getTime() : 0;
        const dateB = b.modifiedDate ? new Date(b.modifiedDate).getTime() : 0;
        if (dateB !== dateA) {
          return dateB - dateA;
        }
        return (b.id ?? 0) - (a.id ?? 0);
      }))
    );
  }

  getRoleById(id: number): Observable<Role> {
    return this.http.get<Role>(`${this.baseUrl}/${id}`);
  }

  createRole(role: Role): Observable<Role> {
    return this.http.post<Role>(this.baseUrl, role);
  }

  updateRole(id: number, role: Role): Observable<Role> {
    return this.http.put<Role>(`${this.baseUrl}/${id}`, role);
  }

  deleteRole(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  archiveUser(userId: number): Observable<void> {
    return this.http.put<void>(`${environment.apiUrl}/user-roles/${userId}/archive`, {});
  }

  reactivateUser(userId: number): Observable<void> {
    return this.http.put<void>(`${environment.apiUrl}/user-roles/${userId}/reactivate`, {});
  }
}